<template>
  <transition name="slide-fade">
    <div class="overlay" v-on:click="$store.commit('setOverlay', null)">
      <div class="close-but"><!--<i class="fa fa-times"></i>-->&#10006;</div>
      <div class="overlay-content">
        <div class="instagram">
          <img  v-bind:src="gram.images.standard_resolution.url">
          <iframe v-if="gram.type === 'youtube'" width="420" height="315" :src="'https://www.youtube.com/embed/' + gram.id"></iframe>
          <div class='outside'>
            <a v-if="gram.type === 'youtube'" :href="'https://youtube.com/watch?v=' + gram.id" target="_blank"><div class='profile' v-bind:style="{ backgroundImage: 'url(' + gram.user.profile_picture + ')' }"></div> {{gram.user.username}}</a>
            <a v-if="gram.type !== 'youtube'" :href="'https://instagram.com/' + gram.user.username" target="_blank"><div class='profile' v-bind:style="{ backgroundImage: 'url(' + gram.user.profile_picture + ')' }"></div> {{gram.user.username}}</a>
            <div class="hearts"><i class="fa fa-heart"></i> {{gram.likes.count}}</div>
          </div>
        </div>
        <a v-if="gram.color === 'blue'" href="http://www.hihonor.com/se/products/mobile-phones/honor9/index.html" target="_blank" class="product product-blue">
          <!--<div class="arrow-outside">Honor 9 Sapphire Blue</div>-->
        </a>
        <a v-else href="http://www.hihonor.com/se/products/mobile-phones/honor9/index.html" target="_blank" class="product product-grey">
          <!-- <div class="arrow-outside">Honor 9 Glacier Grey</div> -->
        </a>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'overlay',
  computed: {
    gram () {
      return this.$store.state.overlay.gram
    }
  }
}
</script>

<style scoped>
  .close-but {
    position: absolute;
    top: 10vh;
    right: 10vw;
    font-size: 50px;
    cursor: pointer;
    z-index: 9999;
    color: #333;
    color: #fff;
  }
  a {
    color: inherit;
    text-decoration: inherit;
    -webkit-transition: all 300ms;
    transition: all 300ms;
  }
  a:hover {
    color: #32bfe0 !important;
  }
  .instagram {
    height: 60vh;
    text-align: center;
    display: inline-block;
    background-position: left center;
    margin-top: 20vh;
    background-size: contain;
    background-repeat: no-repeat;
    position: relative;
    vertical-align: top;
    box-sizing: border-box;
    max-width: 50%;
    overflow: visible;
  }
  .instagram img {
    height: calc(100% - 46px);
  }
  .instagram iframe {
    border: 0;
    height: calc(100% - 46px);
    width: 30vw;
  }
  .instagram .outside {
    display: block;
    text-align: left;
    text-transform: uppercase;
    font-family: 'BigNoodleTitling';
    padding: 8px;
    padding-left: 0px;
    font-size: 28px;
    color: #333333;
    color: #fff;
    width: 100%;
    box-sizing: border-box;
  }
  .overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: rgba(255, 255, 255, 0.9);
    background-color: rgba(22, 23, 28, 0.8);
    z-index: 999999;
  }
  .overlay-content {
    text-align: center;
    width: 100%;
    max-width: 1600px;
    margin: auto;
    overflow-y: hidden;
    overflow-x: hidden;
  }
  .instagram .profile {
    height: 30px;
    width: 30px;
    margin-right: 5px;
    vertical-align: middle;
    display: inline-block;
    background-size: contain;
    display: none;
  }
  .hearts {
    float: right;
    margin-left: 50px;
    color: #c8ccce;
  }
  .hearts i {
    font-size: 0.9em;
    margin-right: 5px;
  }
  .product {
    vertical-align: top;
    width: 39%;
    position: relative;
    height: 64.5vh;
    display: inline-block;
    background-position: center;
    margin-top: 18vh;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center top;
    -webkit-transition: all 300ms;
    transition: all 300ms;
    margin-bottom: 50px;
  }
  .arrow-outside {
    position: absolute;
    width: 300px;
    left: 50%;
    margin-left: -150px;
    bottom: -26px;
    font-size: 28px;
    color: #333;
    color: #fff;
    font-family: 'BigNoodleTitling';
    text-transform: uppercase;
  }
  .product:hover {
   opacity: 0.8;
    -webkit-transition: all 300ms;
    transition: all 300ms;
  }
  .product-blue {
    background-image: url('./../assets/img/blue_with_usp2-min.png');
  }
  .product-grey {
    background-image: url('./../assets/img/grey_with_usp2-min.png');
  }

  @media only screen and (max-width: 900px) {
  .close-but {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 36px;
    cursor: pointer;
  }
    .instagram {
      max-width: 100%;
      padding: 10px;
      margin-top: 50px;
      text-align: center;
    }
    .instagram img {
      max-width: auto;
      text-align: center;
    }
    .instagram iframe {
      width: 80vw;
    }
    .instagram .outside {
      padding: 10px;
      padding-left: 10px;  
      font-size: 20px;
      bottom: -40px;    
    }
    .overlay-content {
      height: 100%;
      overflow-y: scroll;
    }
    .product {
      width: 100%;
      margin-top: 50px;
      margin-bottom: 100px;
    }
    .instagram {
      width: 100%;
    }
  }
  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-fade-enter-active {
    transition: all .5s ease;
  }
  .slide-fade-leave-active {
    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    /* transform: translateY(100vh); */
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// Overlay.vue?67923e58